import React from 'react'
import Layout from '@/components/shared/Layout'
import Head from 'next/head'
import ScrollAnimation from '@/components/shared/ScrollAnimation'
import ProgramsInfoHero from '@/components/programs/ProgramsInfoHero'
import ProgramFeature from '@/components/programs/ProgramFeature'
import ContactForm from '@/components/shared/ContactForm'
import AvailablePrograms from '@/components/programs/AvailablePrograms'
import Partners from '@/components/shared/Partners'
import WeHelpYou from '@/components/programs/WeHelpYou'
import { useTranslation } from 'next-i18next'
import { META_IMAGE, SITE_URL } from "@/utils/meta";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import ScholarshipCard from '@/components/shared/ScholarshipCard'
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale || "az")),
        },
    };
}

const Programs = () => {
    const { t, i18n } = useTranslation();
    const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/programs`;

    return (
        <Layout>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{t("programs-page.meta-title")}</title>
                <meta name="description" content={t("programs-page.meta-description")} />
                <meta name="image" content={META_IMAGE} />
                <link rel="canonical" href={pageUrl} />
                <meta property="og:site_name" content="peerstack.tech" />
                <meta property="og:title" content={t("programs-page.meta-title")} />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:description" content={t("programs-page.meta-description")} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={META_IMAGE} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t("programs-page.meta-title")} />
                <meta name="twitter:url" content={pageUrl} />
                <meta name="twitter:description" content={t("programs-page.meta-description")} />
                <meta name="twitter:image" content={META_IMAGE} />
            </Head>
            <ProgramsInfoHero />
            <ScrollAnimation delay={100}>
                <ScholarshipCard />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <AvailablePrograms />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <WeHelpYou />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <Partners />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <ProgramFeature />
            </ScrollAnimation>
            <ContactForm />
            <ScrollToTopButton />
            <WhatsappButton />
        </Layout>
    )
}

export default Programs